/**
 *
 *  PartnerProductBadge -- used in product lists
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 28/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import PropTypes from "prop-types";

// Icons
import WoBoxingIcon from "../../../icons/WoBoxingIcon";
import WoKickboxingIcon from "../../../icons/WoKickboxingIcon";
import WoYogaIcon from "../../../icons/WoYogaIcon";
import WoPilatesIcon from "../../../icons/WoPilatesIcon";
import WoBalletFitIcon from "../../../icons/WoBalletFitIcon";
import WoPersonalTrainingIcon from "../../../icons/WoPersonalTrainingIcon";
import WoPrePostNatalIcon from "../../../icons/WoPrePostNatalIcon";
import WoMeditationIcon from "../../../icons/WoMeditationIcon";
import WoStretchingIcon from "../../../icons/WoStretchingIcon";
import WoRunningIcon from "../../../icons/WoRunningIcon";
import WoLifestyleCoachingIcon from "../../../icons/WoLifestyleCoachingIcon";
import WoMotivationIcon from "../../../icons/WoMotivationIcon";
import WoSoundBathsIcon from "../../../icons/WoSoundBathsIcon";
import WoStressManagementIcon from "../../../icons/WoStressManagementIcon";
import WoCymbiotikaCertifiedIcon from "../../../icons/WoCymbiotikaCertifiedIcon";
import WoSpiritualGangsterIcon from "../../../icons/WoSpiritualGangsterIcon";

// Utils
import { makeUrlString } from "../../../utils";

const workoutIconsMap = {
  boxing: WoBoxingIcon,
  kickboxing: WoKickboxingIcon,
  yoga: WoYogaIcon,
  pilates: WoPilatesIcon,
  ballet /*balletFit*/: WoBalletFitIcon,
  "personal-training" /*personalTraining*/: WoPersonalTrainingIcon,
  "prepost-natal" /*prePostNatal*/: WoPrePostNatalIcon,
  meditation: WoMeditationIcon,
  stretching: WoStretchingIcon,
  running: WoRunningIcon,
  "lifestyle-coaching": WoLifestyleCoachingIcon,
  "motivational-coaching": WoMotivationIcon,
  "sound-baths": WoSoundBathsIcon,
  "sound-healing": WoSoundBathsIcon,
  "stress-management": WoStressManagementIcon,
  "cymbiotika-certified": WoCymbiotikaCertifiedIcon,
  "spiritual-gangster": WoSpiritualGangsterIcon,
  "spiritual-gangster-certified": WoSpiritualGangsterIcon,
};

export const ProductBadge = ({
  showLabel = true,
  className,
  iconClassName,
  iconSize,
  workoutLabel,
}) => {
  let WorkoutIcon;

  // Correct! JSX type can be a capitalized variable.
  if (workoutLabel) {
    WorkoutIcon = workoutIconsMap[makeUrlString(workoutLabel)];
  }

  WorkoutIcon = WorkoutIcon || WoPersonalTrainingIcon;

  return (
    <li
      className={`tb-disciplines-list-item ${className ? ` ${className}` : ""}`}
    >
      <WorkoutIcon className={iconClassName} size={iconSize} />
      {showLabel ? workoutLabel : null}
    </li>
  );
};

ProductBadge.propTypes = {
  workoutLabel: PropTypes.string,
};

export default ProductBadge;
